import { render, staticRenderFns } from "./RiskmatrixChart.vue?vue&type=template&id=82a20950&scoped=true"
import script from "./RiskmatrixChart.vue?vue&type=script&lang=js"
export * from "./RiskmatrixChart.vue?vue&type=script&lang=js"
import style0 from "./RiskmatrixChart.vue?vue&type=style&index=0&id=82a20950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a20950",
  null
  
)

export default component.exports